<!-- @format -->

<template>
  <FlexCol gap-1>
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <InputArc :disabled :error="error">
      <template #input>
        <input
          v-model="displayValue"
          @input="handleInput"
          :disabled
          :placeholder="placeholder || 'ABC-1234'"
          maxlength="8"
          class="w-full bg-transparent focus:outline-none focus:ring-0 placeholder:italic" />
      </template>
    </InputArc>
    <Error :message="error" v-if="error" />
  </FlexCol>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useUtils } from '@/composables/useUtils'

const { applyLicensePlateMask } = useUtils()

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: String,
  placeholder: String,
})

const emits = defineEmits(['update:modelValue'])

const localValue = ref(props.modelValue)
const displayValue = ref(applyLicensePlateMask(localValue.value))
const error = ref(props.error)

const handleInput = (event) => {
  displayValue.value = applyLicensePlateMask(event.target.value)
}

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
    displayValue.value = applyLicensePlateMask(newValue)
  },
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  },
)

watch(displayValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
